import {DeleteOperation, GetOperation, PostOperation} from '@/api/rest/base/operations';
import BaseApi from './base/BaseApi';
import axios from 'axios';

export default class extends BaseApi {
  static entityName = 'agreements';

  fetchExternal(extId, token, withPreloader = true) {
    const operation = new GetOperation(`/api/agreements/ext/${extId}`, { token });
    return this.execute(operation, withPreloader);
  }

  answerExternal(params = {}, withPreloader = false) {
    const operation = new PostOperation('/api/agreements/ext', params);
    return this.execute(operation, withPreloader);
  }

  uploadFileExternal(extId, token, file, progressCallback = null, abortController = null) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('extId', extId);
    formData.append('token', token);

    return axios.post('/api/agreements/ext/file', formData, {
      signal: abortController.signal,
      onUploadProgress: (progressEvent) => {
        if (progressCallback) {
          const progress = progressEvent.loaded / progressEvent.total;
          progressCallback(progress * 100);
        }
      },
    });
  }

  deleteFileExternal(id, extId, token, withPreloader = true) {
    const operation = new DeleteOperation(`/api/agreements/ext/file/${extId}/${token}/${id}`);
    return this.execute(operation, withPreloader);
  }
}
